import Modernisierung from '../modernisierung';
import konstanten from '@/js/konstanten';
import objektartKpa from '../objektartKpa';
import Lasten from '../lasten';

const BILD_UPLOAD = 'Es werden noch Bilder hochgeladen!';
const MAX_TEXTFIELD = konstanten.MAX_TEXT_LENGTH;
const MAX_WOHNUNGSNUMMER_TEXTFIELD = konstanten.MAX_WOHNUNGSNUMMER_TEXT_LENGTH;

const allgemeineAngaben = ({
                             ermittlungsstichtag,
                             baujahr,
                             kernsanierung,
                             jahrDerKernsanierung,
                             objektart,
                             anzahlWohneinheiten,
                             anzahlNutzeinheiten,
                             wohnflaeche,
                             nutzflaeche,
                             wohnungsnummer
                           }) => {
  let errors = [];
  if (!ermittlungsstichtag) {
    errors = [...errors, 'Der Ermittlungsstichtag ist verpflichtend anzugeben!'];
  }
  if (!baujahr) {
    errors = [...errors, 'Das Baujahr ist verpflichtend anzugeben!'];
  } else if (baujahr < 1800) {
    errors = [...errors, 'Das Baujahr muss nach 1800 liegen!'];
  }
  if (kernsanierung) {
    if (!jahrDerKernsanierung) {
      errors = [...errors, 'Das Jahr der Kernsanierung ist verpflichtend anzugeben!'];
    } else if (jahrDerKernsanierung <= baujahr) {
      errors = [...errors, 'Das Jahr der Kernsanierung muss nach dem Baujahr liegen!'];
    }
  }
  if (objektart === 'Eigentumswohnung') {
    if (!wohnungsnummer) {
      errors = [...errors, 'Die Wohnungsnummer ist verpflichtend anzugeben!'];
    } else {
      errors = [...errors, ...maxWohnungsnummerLengthRule(wohnungsnummer)];
    }
  }
  if (objektart === 'Mehrfamilienhaus') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl der Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
  }
  if (objektart === 'Wohn- und Geschäftshaus') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl der Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!anzahlNutzeinheiten) {
      errors = [...errors, 'Die Anzahl Nutzeinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
    if (!nutzflaeche) {
      errors = [...errors, 'Die Nutzfläche ist verpflichtend anzugeben!'];
    }
  }
  if (objektart === 'Gewerbe bis 500 m²' || objektart === 'Gewerbe 501 bis 1000 m²' || objektart === 'Gewerbe 1001 bis 2500 m²') {
    if (!anzahlNutzeinheiten) {
      errors = [...errors, 'Die Anzahl Nutzeinheiten ist verpflichtend anzugeben!'];
    }
    if (!nutzflaeche) {
      errors = [...errors, 'Die Nutzfläche ist verpflichtend anzugeben!'];
    }
  }
  return errors;
};

const allgemeineAngabenObjektbesichtigung = ({
                             ermittlungsstichtag,
                             baujahr,
                             objektart,
                             anzahlWohneinheiten,
                             anzahlNutzeinheiten,
                             wohnflaeche,
                             nutzflaeche,
                             wohnungsnummer
                           }) => {
  let errors = [];
  if (!ermittlungsstichtag) {
    errors = [...errors, 'Der Ermittlungsstichtag ist verpflichtend anzugeben!'];
  }
  if (!baujahr) {
    errors = [...errors, 'Das Baujahr ist verpflichtend anzugeben!'];
  } else if (baujahr < 1800) {
    errors = [...errors, 'Das Baujahr muss nach 1800 liegen!'];
  }
  if (objektart === 'Eigentumswohnung') {
    if (!wohnungsnummer) {
      errors = [...errors, 'Die Wohnungsnummer ist verpflichtend anzugeben!'];
    } else {
      errors = [...errors, ...maxWohnungsnummerLengthRule(wohnungsnummer)];
    }
  }
  if (objektart === 'Mehrfamilienhaus') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl der Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
  }
  if (objektart === 'Wohn- und Geschäftshaus') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl der Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!anzahlNutzeinheiten) {
      errors = [...errors, 'Die Anzahl Nutzeinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
    if (!nutzflaeche) {
      errors = [...errors, 'Die Nutzfläche ist verpflichtend anzugeben!'];
    }
  }
  if (objektart === 'Gewerbe bis 500 m²' || objektart === 'Gewerbe 501 bis 1000 m²' || objektart === 'Gewerbe 1001 bis 2500 m²') {
    if (!anzahlNutzeinheiten) {
      errors = [...errors, 'Die Anzahl Nutzeinheiten ist verpflichtend anzugeben!'];
    }
    if (!nutzflaeche) {
      errors = [...errors, 'Die Nutzfläche ist verpflichtend anzugeben!'];
    }
  }
  return errors;
};

const allgemeineAngabenKpa = ({
                                auftraggeberName1,
                                auftraggeberName2,
                                objektart,
                                baujahr,
                                ermittlungsstichtag,
                                anzahlWohneinheiten,
                                anzahlNutzeinheiten,
                                wohnflaeche,
                                nutzflaeche,
                                wohnungsnummer
                              }) => {
  let errors = [];
  if (!auftraggeberName1 && !auftraggeberName2) {
    errors = [...errors, 'Der Auftraggeber ist verpflichtend anzugeben!'];
  }
  if (!objektartKpa.values().includes(objektart)) {
    errors = [...errors, 'Die Objektart ist verpflichtend anzugeben!'];
  }
  if (!baujahr) {
    errors = [...errors, 'Das Baujahr ist verpflichtend anzugeben!'];
  } else if (baujahr < 1800) {
    errors = [...errors, 'Das Baujahr muss nach 1800 liegen!'];
  } else if (baujahr > new Date().getFullYear()) {
    errors = [...errors, 'Das Baujahr darf nicht in der Zukunft liegen!'];
  }
  if (!ermittlungsstichtag) {
    errors = [...errors, 'Der Ermittlungsstichtag ist verpflichtend anzugeben!'];
  } else if (new Date(ermittlungsstichtag) < new Date('2000-01-01')) {
    errors = [...errors, 'Der Ermittlungsstichtag muss nach dem 01.01.2000 liegen!'];
  } else if (new Date(ermittlungsstichtag) > new Date()) {
    errors = [...errors, 'Der Ermittlungsstichtag darf nicht in der Zukunft liegen!'];
  }
  if (objektart === 'ETW') {
    if (!wohnungsnummer) {
      errors = [...errors, 'Die Wohnungsnummer ist verpflichtend anzugeben!'];
    } else {
      errors = [...errors, ...maxWohnungsnummerLengthRule(wohnungsnummer)];
    }
  }
  if (objektart === 'MFH') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
  }
  if (objektart === 'WGH') {
    if (!anzahlWohneinheiten) {
      errors = [...errors, 'Die Anzahl Wohneinheiten ist verpflichtend anzugeben!'];
    }
    if (!anzahlNutzeinheiten) {
      errors = [...errors, 'Die Anzahl Nutzeinheiten ist verpflichtend anzugeben!'];
    }
    if (!wohnflaeche) {
      errors = [...errors, 'Die Wohnfläche ist verpflichtend anzugeben!'];
    }
    if (!nutzflaeche) {
      errors = [...errors, 'Die Nutzfläche ist verpflichtend anzugeben!'];
    }
  }
  return errors;
};

const modernisierungenKpa = ({
                            kernsanierung,
                            jahrDerKernsanierung,
                            bodenbelaege,
                            baeder,
                            heizung,
                            leitungen,
                            fenster,
                            daemmung,
                            dach,
                            raumaufteilung
                          }, {baujahr}) => {
  let errors = [];
  if (kernsanierung) {
    if (!jahrDerKernsanierung) {
      errors = [...errors, 'Das Jahr der Kernsanierung ist verpflichtend anzugeben!'];
    } else if (jahrDerKernsanierung <= baujahr) {
      errors = [...errors, 'Das Jahr der Kernsanierung muss nach dem Baujahr liegen!'];
    }
  }
  return [
    ...errors,
    ...gefacheSimple({...bodenbelaege}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Bodenbeläge, Wandverkleidung und Treppenhaus)'),
    ...gefacheSimple({...baeder}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Bäder und WCs)'),
    ...gefacheSimple({...heizung}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Heizung)'),
    ...gefacheSimple({...leitungen}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Strom, (Ab)Wasser, Heizungsleitungen und Heizkörper)'),
    ...gefacheSimple({...fenster}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Fenster)'),
    ...gefacheSimple({...daemmung}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Wärmedämmung)'),
    ...gefacheSimple({...dach}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Dach)'),
    ...gefacheSimple({...raumaufteilung}, {baujahr, kernsanierung, jahrDerKernsanierung}, '(Raumaufteilung)')];
};

const modernisierungenObjektbesichtigung = (
  {aussenwaende, dach, fenster, fussboeden, innenwaende, decken, sanitaer, heizung, technischeAusstattung},
  {kernsanierung, jahrDerKernsanierung, baujahr},
) => {
  let errors = [];
  if (kernsanierung) {
    if (!jahrDerKernsanierung) {
      errors = [...errors, 'Das Jahr der Kernsanierung ist verpflichtend anzugeben!'];
    } else if (jahrDerKernsanierung <= baujahr) {
      errors = [...errors, 'Das Jahr der Kernsanierung muss nach dem Baujahr liegen!'];
    }
  }
  return [
    ...errors,
    ...gefacheSimple({ ...aussenwaende }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Außenwände)'),
    ...gefacheSimple({ ...dach }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Dach)'),
    ...gefacheSimple({ ...fenster }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Fenster)'),
    ...gefacheSimple({ ...fussboeden }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Fußböden)'),
    ...gefacheSimple({ ...innenwaende }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Innenwände)'),
    ...gefacheSimple({ ...decken }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Decken)'),
    ...gefacheSimple({ ...sanitaer }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Sanitär)'),
    ...gefacheSimple({ ...heizung }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Heizung)'),
    ...gefacheSimple({ ...technischeAusstattung }, { baujahr, kernsanierung, jahrDerKernsanierung }, '(Technische Ausstattung)'),
  ];
};

const aussenwaendeGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.aussenansichtVorne === undefined) {
    errors = [...errors, 'Das Bild "Außenansicht vorne" ist verpflichtend anzugeben!'];
  }
  if (fotos.aussenansichtHinten === undefined) {
    errors = [...errors, 'Das Bild "Außenansicht hinten" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const dachGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.dacheindeckungAussen === undefined) {
    errors = [...errors, 'Das Bild "Dacheindeckung außen" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const fensterGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.hauseingangstuer === undefined) {
    errors = [...errors, 'Das Bild "Hauseingangstür" ist verpflichtend anzugeben!'];
  }
  if (fotos.fenster === undefined) {
    errors = [...errors, 'Das Bild "Fenster" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const fussboedenGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.fussboden1 === undefined) {
    errors = [...errors, 'Das Bild "Fußboden 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.fussboden2 === undefined) {
    errors = [...errors, 'Das Bild "Fußboden 2" ist verpflichtend anzugeben!'];
  }
  if (fotos.fussboden3 === undefined) {
    errors = [...errors, 'Das Bild "Fußboden 3" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const innenwaendeGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.innentuer1 === undefined) {
    errors = [...errors, 'Das Bild "Innentür 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.innentuer2 === undefined) {
    errors = [...errors, 'Das Bild "Innentür 2" ist verpflichtend anzugeben!'];
  }
  if (fotos.innenwand1 === undefined) {
    errors = [...errors, 'Das Bild "Innenwand 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.innenwand2 === undefined) {
    errors = [...errors, 'Das Bild "Innenwand 2" ist verpflichtend anzugeben!'];
  }
  if (fotos.innenwand3 === undefined) {
    errors = [...errors, 'Das Bild "Innenwand 3" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const deckenGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.treppe1 === undefined) {
    errors = [...errors, 'Das Bild "Treppe 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.treppe2 === undefined) {
    errors = [...errors, 'Das Bild "Treppe 2" ist verpflichtend anzugeben!'];
  }
  if (fotos.deckenkonstruktion1 === undefined) {
    errors = [...errors, 'Das Bild "Deckenkonstruktion 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.deckenkonstruktion2 === undefined) {
    errors = [...errors, 'Das Bild "Deckenkonstruktion 2" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const sanitaerGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.bad1 === undefined) {
    errors = [...errors, 'Das Bild "Bad 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.bad2 === undefined) {
    errors = [...errors, 'Das Bild "Bad 2" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const heizungGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.heizungsanlage1 === undefined) {
    errors = [...errors, 'Das Bild "Heizungsanlage 1" ist verpflichtend anzugeben!'];
  }
  if (fotos.heizungsanlage2 === undefined) {
    errors = [...errors, 'Das Bild "Heizungsanlage 2" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const technischeAusstattungGutachten = (
  {modernisierung, jahrDerModernisierung, erlaeuterung, fotos},
  {baujahr, kernsanierung, jahrDerKernsanierung},
) => {
  let errors = gefache(
    {modernisierung, jahrDerModernisierung, erlaeuterung},
    {baujahr, kernsanierung, jahrDerKernsanierung},
  );
  if (fotos.sicherungskasten === undefined) {
    errors = [...errors, 'Das Bild "Sicherungskasten" ist verpflichtend anzugeben!'];
  }
  if (fotos.steckdosen === undefined) {
    errors = [...errors, 'Das Bild "Steckdosen/Lichtschalter" ist verpflichtend anzugeben!'];
  }
  return [...errors, ...validateDokumentUpload(fotos)];
};

const objektunterlagen = ({
                            grundriss,
                            zusatzdokumentGrundriss,
                            energieausweis,
                            zusatzdokumentEnergieausweis,
                          }) => {
  let errors = [];
  if (energieausweis === undefined) {
    errors = [...errors, 'Die Datei "Energieausweis" ist verpflichtend anzugeben!'];
  }
  return [
    ...errors,
    ...validateDokumentUpload({
      grundriss,
      zusatzdokumentGrundriss,
      energieausweis,
      zusatzdokumentEnergieausweis,
    }),
  ];
};

const objektunterlagenObjektbesichtigung = ({
                            grundriss,
                            zusatzdokumentGrundriss,
                            energieausweis,
                            zusatzdokumentEnergieausweis,
                          }) => {
  return [
    ...validateDokumentUpload({
      grundriss,
      zusatzdokumentGrundriss,
      energieausweis,
      zusatzdokumentEnergieausweis,
    }),
  ];
};

const auftragsunterlagen = ({
                              grundbuchauszug,
                              kaufvertrag,
                              grundriss,
                              mietvertraege,
                              energieausweis,
                              bauunterlagen,
                              teilungserklaerung,
                              zusatzdokument
                            }, {vermietetKaufzeitpunkt}) => {
  let errors = [];
  if (grundbuchauszug === undefined) {
    errors = [...errors, 'Die Datei "Grundbuchauszug" ist verpflichtend anzugeben!'];
  }
  if (kaufvertrag === undefined) {
    errors = [...errors, 'Die Datei "Kaufvertrag" ist verpflichtend anzugeben!'];
  }
  if (grundriss === undefined) {
    errors = [...errors, 'Die Datei "Grundriss" ist verpflichtend anzugeben!'];
  }
  if (vermietetKaufzeitpunkt && mietvertraege === undefined) {
    errors = [...errors, 'Die Datei "Mietaufstellung / Mietverträge" ist verpflichtend anzugeben, wenn das Objekt vermietet ist!'];
  }
  let zusatz = zusatzdokument === undefined ? [] : zusatzdokument;
  return [
    ...errors,
    ...validateDokumentUpload({
      grundbuchauszug,
      kaufvertrag,
      grundriss,
      mietvertraege,
      energieausweis,
      bauunterlagen,
      teilungserklaerung,
      ...zusatz
    }),
  ];
};

const ansprechpartner = ({nachname, vorname, telefon, altName, altFunktion, altTelefon, altEmail}) => {
  let errors = [];
  if (nachname === undefined) {
    errors = [...errors, 'Der Nachname ist verpflichtend anzugeben!'];
  }
  if (vorname === undefined) {
    errors = [...errors, 'Der Vorname ist verpflichtend anzugeben!'];
  }
  if (telefon === undefined) {
    errors = [...errors, 'Die Telefonnummer ist verpflichtend anzugeben!'];
  } else {
    errors = [...errors, ...telefonRule(telefon)];
  }
  if (altTelefon !== undefined) {
    errors = [...errors, ...telefonRule(altTelefon)];
  }
  if (altEmail !== undefined) {
    errors = [...errors, ...emailRule(altEmail)];
  }
  return errors;
};

const defaultRechnung = ({name1, name2, ort, plz, str, hnr}) => {
  let errors = [];
  if (name1 === undefined) {
    errors = [...errors, 'Der Nachname ist verpflichtend anzugeben'];
  }
  if (name2 === undefined) {
    errors = [...errors, 'Der Vorname ist verpflichtend anzugeben!'];
  }
  if (ort === undefined) {
    errors = [...errors, 'Die Postleitzahl ist verpflichtend anzugeben!'];
  }
  if (plz === undefined) {
    errors = [...errors, 'Der Ort ist verpflichtend anzugeben!'];
  }
  if (str === undefined) {
    errors = [...errors, 'Die Straße ist verpflichtend anzugeben!'];
  }
  if (hnr === undefined) {
    errors = [...errors, 'Die Hausnummer ist verpflichtend anzugeben!'];
  }
  return errors;
};

const alternativeRechnung = ({name1, name2, ort, plz, str, hnr, useDefault}) => {
  let errors = [];
  if (useDefault === false) {
    if (!name1) {
      errors = [...errors, 'Der Nachname ist verpflichtend anzugeben'];
    }
    if (!name2) {
      errors = [...errors, 'Der Vorname ist verpflichtend anzugeben!'];
    }
    if (!ort) {
      errors = [...errors, 'Die Postleitzahl ist verpflichtend anzugeben!'];
    }
    if (!plz) {
      errors = [...errors, 'Der Ort ist verpflichtend anzugeben!'];
    }
    if (!str) {
      errors = [...errors, 'Die Straße ist verpflichtend anzugeben!'];
    }
    if (!hnr) {
      errors = [...errors, 'Die Hausnummerist verpflichtend anzugeben!'];
    }
  }
  return errors;
};

const auftragsdaten = ({
                         kaufpreis,
                         grundstuecksflaeche,
                         grunderwerbssteuern,
                         notarkostenKaufvertrag,
                         kostenGrundbucheintragung,
                         bodenrichtwertKaufzeitpunkt,
                         vermietetKaufzeitpunkt,
                         kaltmieteKaufzeitpunkt
                       }) => {
  let errors = [...euroRule('Der Kaufpreis', false, kaufpreis, false)];
  if (grundstuecksflaeche === undefined) {
    errors = [...errors, 'Die Grundstücksfläche ist verpflichtend anzugeben!'];
  } else if (grundstuecksflaeche <= 0.0) {
    errors = [...errors, 'Die Grundstücksfläche muss größer als 0m² sein!'];
  }
  errors = [...errors,
    ...euroRule('Die Grunderwerbssteuern', true, grunderwerbssteuern, true),
    ...euroRule('Die Notarkosten zu Beurkundung des Kaufvertrags', true, notarkostenKaufvertrag, true),
    ...euroRule('Die Kosten der Grundbucheintragung', true, kostenGrundbucheintragung, true),
    ...euroRule('Der Bodenrichtwert pro m² zum Kaufvertragsdatum', false, bodenrichtwertKaufzeitpunkt, false)
  ];
  if (vermietetKaufzeitpunkt) {
    errors = [...errors, ...euroRule('Die Nettokaltmiete gesamt pro Monat zum Kaufvertragsdatum', false, kaltmieteKaufzeitpunkt, false)];
  }
  return errors;
};

const lasten = ({
                  baulasten,
                  erlaeuterungBaulasten,
                  altlasten,
                  erlaeuterungAltlasten,
                }) => {
  let errors = [];
  if (baulasten === Lasten.JA.value && (erlaeuterungBaulasten === undefined || erlaeuterungBaulasten.trim()?.length <= 0)) {
    errors = [...errors, 'Bei bestehenden Baulasten ist eine Erläuterung anzugeben!'];
  }
  if (altlasten === Lasten.JA.value && (erlaeuterungAltlasten === undefined || erlaeuterungAltlasten.trim()?.length <= 0)) {
    errors = [...errors, 'Bei bestehenden Altlasten ist eine Erläuterung anzugeben!'];
  }
  return errors;
};

const gefache = (
  {modernisierung, jahrDerModernisierung, erlaeuterung},
  {baujahr, kernsanierung, jahrDerKernsanierung}
) => {
  let errors = [];
  if (erlaeuterung === undefined || erlaeuterung.trim()?.length <= 0) {
    errors = [...errors, 'Ausführung/Material ist gemäß dem Leitfaden anzugeben!'];
  } else {
    errors = [...errors, ...maxLengthRule(erlaeuterung)];
  }
  return [
    ...errors,
    ...gefacheSimple({modernisierung, jahrDerModernisierung}, {baujahr, kernsanierung, jahrDerKernsanierung}, '')
  ];
};

const gefacheSimple = ({modernisierung, jahrDerModernisierung},
                       {baujahr, kernsanierung, jahrDerKernsanierung},
                       name) => {
  let errors = [];
  if (modernisierung !== Modernisierung.KEINE.value) {
    if (jahrDerModernisierung === undefined) {
      errors = [...errors, `${name} Das Jahr der Modernisierung ist verpflichtend anzugeben!`];
    } else if (jahrDerModernisierung <= baujahr) {
      errors = [...errors, `${name} Das Jahr der Modernisierung muss nach dem Baujahr liegen!`];
    } else if (kernsanierung && jahrDerModernisierung <= jahrDerKernsanierung) {
      errors = [
        ...errors,
        `${name} Das Jahr der Modernisierung muss nach dem jahr der Kernsanierung liegen!`,
      ];
    } else if (jahrDerModernisierung > new Date().getFullYear()) {
      errors = [...errors, `${name} Das Jahr der Modernisierung darf nicht in der Zukunft liegen!`];
    }
  }
  return errors;
};

const validateDokumentUpload = path => {
  if (
    Object.values(path)
      .flatMap(a => a)
      .map(file => file?.isStillUploading())
      .reduce((a, b) => a || b, false)
  ) {
    return [BILD_UPLOAD];
  } else {
    return [];
  }
};

export const telefonRule = nummer => {
  const pattern = /(\(?([\d \-)–+/(]+){6,}\)?([ .\-–/]?)(\d+))/;
  if (!nummer || pattern.test(nummer)) {
    return [];
  } else {
    return ['Bitte geben Sie eine gültige Telefonnummer an!'];
  }
};

export const emailRule = email => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!email || pattern.test(email)) {
    return [];
  } else {
    return ['Bitte geben Sie eine gültige E-Mail-Adresse an!'];
  }
};

export const maxLengthRule = text => {
  if (!text || text.length <= MAX_TEXTFIELD) {
    return [];
  } else {
    return [`Das Feld darf maximal ${MAX_TEXTFIELD} Zeichen lang sein!`];
  }
};

export const maxWohnungsnummerLengthRule = text => {
  if (!text || text.length <= MAX_WOHNUNGSNUMMER_TEXTFIELD) {
    return [];
  } else {
    return [`Die Wohnungsnummer darf maximal ${MAX_WOHNUNGSNUMMER_TEXTFIELD} Zeichen lang sein!`];
  }
};

export const euroRule = (name, multi, value, zeroAllowed) => {
  if (value === undefined) {
    return [`${name} ist verpflichtend anzugeben!`];
  }
  if (zeroAllowed && value < 0.0 || !zeroAllowed && value <= 0.0) {
    let mult = multi ? 'müssen' : 'muss';
    let text = zeroAllowed ? 'größer oder gleich' : 'größer als';
    return [`${name} ${mult} ${text} 0,00€ sein!`];
  }
  return [];
};

export const gutachten = {
  allgemeineAngaben,
  aussenwaendeGutachten,
  dachGutachten,
  fensterGutachten,
  fussboedenGutachten,
  innenwaendeGutachten,
  deckenGutachten,
  sanitaerGutachten,
  heizungGutachten,
  technischeAusstattungGutachten,
  objektunterlagen,
  ansprechpartner,
  defaultRechnung,
  alternativeRechnung
};

export const objektbesichtigung = {
  allgemeineAngabenObjektbesichtigung,
  modernisierungenObjektbesichtigung,
  objektunterlagenObjektbesichtigung,
  ansprechpartner,
  defaultRechnung,
  alternativeRechnung
};

export const kaufpreisaufteilung = {
  allgemeineAngabenKpa,
  auftragsdaten,
  lasten,
  modernisierungenKpa,
  auftragsunterlagen,
  ansprechpartner,
  defaultRechnung,
  alternativeRechnung
};
